import { render, staticRenderFns } from "./Divisiones.vue?vue&type=template&id=20ee8d9c&scoped=true&"
import script from "./Divisiones.vue?vue&type=script&lang=js&"
export * from "./Divisiones.vue?vue&type=script&lang=js&"
import style0 from "./Divisiones.vue?vue&type=style&index=0&id=20ee8d9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ee8d9c",
  null
  
)

export default component.exports